// 加
const add = (a, b) => {
    let c;
    let d;
    try {
      c = a.toString().split('.')[1].length;
    } catch (f) {
      c = 0;
    }
    try {
      d = b.toString().split('.')[1].length;
    } catch (f) {
      d = 0;
    }
    const e = 10 ** (Math.max(c, d));
    return (mul(a, e) + mul(b, e)) / e;
  };

  // 减
  const sub = (a, b) => {
    let c;
    let d;
    try {
      c = a.toString().split('.')[1].length;
    } catch (f) {
      c = 0;
    }
    try {
      d = b.toString().split('.')[1].length;
    } catch (f) {
      d = 0;
    }
    const e = 10 ** (Math.max(c, d));
    return (mul(a, e) - mul(b, e)) / e;
  };

  // 乘
  const mul = (a, b) => {
    let c = 0;
    const d = a.toString();
    const e = b.toString();
    try {
      c += d.split('.')[1].length;
    } catch (f) {
      c += 0;
    }
    try {
      c += e.split('.')[1].length;
    } catch (f) {
      c += 0;
    }
    return Number(d.replace('.', '')) * Number(e.replace('.', '')) / (10 ** c);
  };

  // 除
  const div = (a, b) => {
    let e = 0;
    let f = 0;
    try {
      e = a.toString().split('.')[1].length;
    } catch (g) {
      e = 0;
    }
    try {
      f = b.toString().split('.')[1].length;
    } catch (g) {
      f = 0;
    }
    const c = Number(a.toString().replace('.', ''));
    const d = Number(b.toString().replace('.', ''));
    return mul(c / d, (10 ** (f - e)));
  };

  export default {
    add,
    sub,
    mul,
    div,
  };
